import _ from 'lodash';

import frontEndVars from '~/front-end-vars';
import { waitForImages, onTextareaResize, offTextareaResize } from '~/common';
import $ from '~/qwery';
import bean from '~/bean';
import Overlay from '~/components/popup/overlay';
import PopupWrapper from '~/components/popup/wrapper';
import popupManager from '~/components/popup/manager';
import Header from '~/components/popup/header';
import Buttons from '~/components/popup/buttons';

export default class Popup {
    constructor(options = {}) {
        if (options['noInit'])
            return;
        this.init(options);
    }

    init(options) {
        this._options = {};
        popupManager.adopt(this);
        this.options(options);
        this._overlay = new Overlay({
            onClick: this.destroy.bind(this),
        });

        this.$el = $(document.createElement('div'));
        this.$el.attr('class',
            ['b-popup', 'b-frame'].concat(
                [this.options('mode') == 'hideViewportScrollbars'
                    ? 'position-static'
                    : 'position-fixed'],
                this.options('class') instanceof Array
                    ? this.options('class')
                    : [this.options('class')])
            .join(' '));
        this.$el.css('visibility', 'hidden');
        this.$el.html(_.template(
            '<div class="header-place"></div>'
            + '<div class="b-popup-content">'
                + this.options('content')
            + '</div>'
            + '<div class="buttons-place"></div>'
        )(Object.assign({
            options: this.options(),
        }, this.options('templateVars'))));
        this.options('afterRenderTemplate') && this.options('afterRenderTemplate')();

        this._header = new Header($('.header-place', this.$el), {
            title: this.options('title'),
            textCloseButton: this.options('textCloseButton'),
            onCloseClick: this.destroy.bind(this),
        });

        if (this.options('buttons')) {
            this._buttons = new Buttons($('.buttons-place', this.$el),
                this.options('buttons'));
        }

        this._wrapper = new PopupWrapper(this.$el, {
            mode: this.options('mode'),
            scrollbars: (this.options('noPopupScrollbarState') || (() => {}))(),
        });

        this.options('beforeWaitForImages') && this.options('beforeWaitForImages')();
        waitForImages(this.$el).then(() => {
            this.updateExtents('popupShow');
            this.$el.css('visibility', 'visible');

            this._textareaResizeEventHandler = textarea => {
                if (this.$el.has(textarea))
                    this.updateExtents('popupResize');
            };
            onTextareaResize(this._textareaResizeEventHandler);

            bean.on(this.$el[0], 'click', e => {
                this._wrapper.popupClicked(true);
            });
            this._wrapper.options({
                onClick: this.destroy.bind(this),
            });

            this._shown = true;
            this.options('afterShow').forEach(callback => callback());
        });
    }

    updateExtents(event) {
        if (this.options('mode') == 'hideViewportScrollbars') {
            this._wrapper.updateExtents();
        } else {
            const hadPositionAbsolute = this.$el.hasClass('position-absolute');

            const minClientHeight = parseFloat(frontEndVars['popup-min-margin'])
                + this.$el[0].offsetHeight
                + parseFloat(frontEndVars['popup-min-margin']);

            const minClientWidth = parseFloat(frontEndVars['popup-min-margin'])
                + this.$el[0].offsetWidth
                + parseFloat(frontEndVars['popup-min-margin']);

            const willHavePositionAbsolute =
                document.documentElement.clientWidth < minClientWidth
                || document.documentElement.clientHeight < minClientHeight;

            if ( ! (hadPositionAbsolute && willHavePositionAbsolute)) {
                let top = Math.round((
                    document.documentElement.clientHeight - this.$el[0].offsetHeight
                ) / 3);
                if (top < parseFloat(frontEndVars['popup-min-margin']))
                    top = parseFloat(frontEndVars['popup-min-margin']);
                if (willHavePositionAbsolute)
                    top = window.pageYOffset + top;
                this.$el.css('top', top + 'px');

                let left = Math.round((
                    document.documentElement.clientWidth - this.$el[0].offsetWidth
                ) / 2);
                if (left < parseFloat(frontEndVars['popup-min-margin']))
                    left = parseFloat(frontEndVars['popup-min-margin']);
                if (willHavePositionAbsolute)
                    left = window.pageXOffset + left;
                this.$el.css('left', left + 'px');
            }
            const method = willHavePositionAbsolute ? 'addClass' : 'removeClass';
            this.$el[method]('position-absolute');
        }
        if (this.options('onUpdateExtents'))
            this.options('onUpdateExtents')(event);
    }

    onEnter() {
        return this._buttons.press('ok-button');
    }

    destroy() {
        if (this.options('onDestroy')) {
            const r = this.options('onDestroy')();
            if (r == false)
                return false;
        }
        this.options('beforeDestroy') && this.options('beforeDestroy')();
        offTextareaResize(this._textareaResizeEventHandler);
        this._wrapper.destroy();
        this._overlay.destroy();
        this._shown = false;
        this.options('afterDestroy') && this.options('afterDestroy')();
    }


    options(options) {
        if (options != null && typeof options != 'string') {
            const afterShow = (this.options('afterShow') || [])
                .concat(options['afterShow'] || []);
            Object.assign(this._options, options, {afterShow});
        }
        return options && typeof options == 'string'
            ? this._options[options]
            : this._options;
    }

    getBoundingClientRect() {
        return this.$el[0].getBoundingClientRect();
    }

    maxContentWidth() {
        const r = this._wrapper.maxContentWidth()
            - (this.options('mode') != 'hideViewportScrollbars'
                ? 2 * parseFloat(frontEndVars['popup-min-margin'])
            : 0)
            - parseFloat(this.$el.css('padding-left'))
            - parseFloat(this.$el.css('padding-right'));
        return Math.max(r, this._header.$el[0].offsetWidth);
    }

    maxContentHeight() {
        return this._wrapper.maxContentHeight()
            - (this.options('mode') != 'hideViewportScrollbars'
                ? 2 * parseFloat(frontEndVars['popup-min-margin'])
            : 0)
            - parseFloat(this.$el.css('padding-top'))
            - this._header.height()
            - parseFloat(this._header.$el.css('margin-bottom'))
            - parseFloat(this.$el.css('padding-bottom'));
    }

    shown() {
        return this._shown;
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/popup/popup.js